import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pokedex-data data-list" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "data-list__title" }, "Pokédex Data", -1)
const _hoisted_3 = { class: "data-list__info" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "data-list__info-title" }, "Pokèdex Num.", -1)
const _hoisted_5 = { class: "data-list__info" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "data-list__info-title" }, "Types", -1)
const _hoisted_7 = { class: "pokedex-data__types" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "data-list__info" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", { class: "data-list__info-title" }, "Height", -1)
const _hoisted_11 = { class: "data-list__info" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", { class: "data-list__info-title" }, "Weight", -1)
const _hoisted_13 = { class: "data-list__info" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", { class: "data-list__info-title" }, "Abilities", -1)
const _hoisted_15 = { class: "pokedex-data__abilities" }
const _hoisted_16 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createTextVNode(" " + _toDisplayString(_ctx.pokedexNum), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (type) => {
          return (_openBlock(), _createElementBlock("span", {
            class: _normalizeClass(['app__type-pill', `app__type-pill--${type}`]),
            key: type
          }, [
            _createTextVNode(_toDisplayString(type) + " ", 1),
            _createElementVNode("img", {
              class: "app__type-pill-icon",
              src: _ctx.loadTypeImg(type),
              alt: `${type} icon`
            }, null, 8, _hoisted_8)
          ], 2))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createTextVNode(" " + _toDisplayString(_ctx.height) + " m ", 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createTextVNode(" " + _toDisplayString(_ctx.weight) + " kg ", 1)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("ol", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.abilities, (abilitySlot) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass([
            'data-list__ability',
            abilitySlot.is_hidden ? 'data-list__ability--hidden' : '',
          ]),
            key: abilitySlot.ability.name
          }, [
            _createTextVNode(_toDisplayString(abilitySlot.ability.name.replace("-", " ")) + " ", 1),
            (abilitySlot.is_hidden)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "(Hidden)"))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ])
    ])
  ]))
}